<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 22 20"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M10 2v16h2V2h-2zm3-2c.552 0 1 .448 1 1v18c0 .552-.448 1-1 1H9c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1h4zm8 5c.552 0 1 .448 1 1v13c0 .552-.448 1-1 1h-4c-.552 0-1-.448-1-1V6c0-.552.448-1 1-1h4zM5 10c.552 0 1 .448 1 1v8c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1v-8c0-.552.448-1 1-1h4zm15-3h-2v11h2V7zM4 12H2v6h2v-6z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-balance",
  components: {},
})
export class IconBalance extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconBalance;
</script>
